import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
export function MetaPixel() {
  useEffect(() => {
    initMetaPixel('948562944236732');
  }, []);
  return <noscript data-id="element-112">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=948562944236732&ev=PageView&noscript=1" alt="" data-id="element-113" />
    </noscript>;
}